import React, { useState } from 'react';

const DEFAULT_BORDER = '#E8761D';
const DEFAULT_TEXT   = '#FFA500';

const BackToDashboardButton = ({
  onClick,
  className = 'jf-back-btn',
  style = {},
  hoverColor = '#FFC107'
}) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <button
      type="button"
      className={className}
      style={{
        backgroundColor: isHovering ? hoverColor : 'black',
        color: isHovering ? 'black' : DEFAULT_TEXT,
        border: `4px solid ${isHovering ? hoverColor : DEFAULT_BORDER}`,
        fontWeight: 900,
        fontSize: '14px',
        padding: '12px 18px',
        textTransform: 'uppercase',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        boxShadow: isHovering ? `0 0 10px ${hoverColor}` : 'none',
        transform: isHovering ? 'translateY(-1px)' : 'translateY(0)',
        transition:
          'background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease',
        ...style
      }}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onClick={onClick}
    >
      ← BACK TO DASHBOARD
    </button>
  );
};

export default BackToDashboardButton;
